import { render } from "./TheSidebar.vue?vue&type=template&id=184427c8"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__